import styled from 'styled-components'

export const EditableCellValue = styled.div`
    padding: 0;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    min-height: 21px;
`

export const TdStyled = styled.td<{
    ['data-editing']?: boolean
    $textColor?: string
}>`
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;

    padding: ${p => (p['data-editing'] ? '0px !important' : '')};

    ${p => (p.$textColor ? `color: ${p.$textColor} !important;` : '')}

    & .ant-input-number,
    & .ant-select,
    & .ant-space-compact,
    & .ant-space-compact .ant-btn {
        /* height: 29.5714px; // это высота компактной маленькой ячейки */
        height: 28.5714px;
    }

    /* &:hover {
        box-shadow: 0px 0px 4px -1px #444444;
        z-index: 1;
    } */
`

export const SimpleTdInner = styled.div`
    /* padding: 0;
    overflow: hidden;
    white-space: nowrap; */
    /* text-overflow: ellipsis; */
    /* max-width: 100px; */
    /* min-height: 21px; */
`
